module.exports = __webpack_public_path__ + "static/media/gym_02.3e35eb27.svg";